"use client";

import { deletePermissionsCookie } from "@/features/privileges/user-roles";
import { signOut } from "next-auth/react";

let signOutInFlight: Promise<void> | null = null;

async function clearLocalSession(redirectUrl = "/auth/login") {
  await deletePermissionsCookie();
  await signOut({ redirect: false });
  window.location.href = redirectUrl;
}

export async function federatedLogout() {
  try {
    const res = await fetch("/api/auth/federated-logout");
    const data = await res.json();
    await clearLocalSession(data.url || "/auth/login");
  } catch {
    await clearLocalSession();
  }
}

export async function localLogout(redirectUrl = "/auth/login") {
  if (signOutInFlight) {
    return signOutInFlight;
  }

  signOutInFlight = clearLocalSession(redirectUrl).finally(() => {
    signOutInFlight = null;
  });

  return signOutInFlight;
}
